var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconXSignCircleSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.25C3.72 0.25 0.25 3.72 0.25 8C0.25 12.28 3.72 15.75 8 15.75C12.28 15.75 15.75 12.28 15.75 8C15.75 3.72 12.28 0.25 8 0.25ZM11.53 10.47C11.82 10.76 11.82 11.24 11.53 11.53C11.24 11.82 10.76 11.82 10.47 11.53L8 9.06L5.53 11.53C5.24 11.82 4.76 11.82 4.47 11.53C4.18 11.24 4.18 10.76 4.47 10.47L6.94 8L4.47 5.53C4.18 5.24 4.18 4.76 4.47 4.47C4.76 4.18 5.24 4.18 5.53 4.47L8 6.94L10.47 4.47C10.76 4.18 11.24 4.18 11.53 4.47C11.82 4.76 11.82 5.24 11.53 5.53L9.06 8L11.53 10.47Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXSignCircleSolid);
export default __webpack_public_path__ + "static/media/icon-x-sign-circle-solid.6866295a9838b82bf44bf5dcff26e807.svg";
export { ForwardRef as ReactComponent };